module.exports = __webpack_public_path__ + "static/media/rydz-login-new-image.0809bdb2.png";